import React from 'react';
import { Flex, Text } from 'rebass';

import { RadioTeste } from '@plug/ui/icons';
import { OnlyDesktopText, OnlyDesktopFlex } from '../styles';
import { FirstAdminText, TextGreeting } from './styles';
import { useTranslation } from 'react-i18next';
import { Spacer } from '@plug/ui';

interface Props {
  isOlist?: boolean;
}

const Admin: React.FC<Props> = ({ isOlist }): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Flex flexDirection="column" justifyContent="space-between" height="100%">
      {isOlist ? (
        <TextGreeting>
          <Spacer mt={'70px'} />
          <Text color="#FFFFFF">{'Olá administrador!'}</Text>
        </TextGreeting>
      ) : (
        <>
          <FirstAdminText color="#fff" fontWeight="600" fontSize="32px" lineHeight="40px">
            {t('hubly-dashboard.signup.admin.left-side.greetings')}
            <Text as="span" color="#F03460">
              Administrador
            </Text>
          </FirstAdminText>

          <OnlyDesktopText width="70%" color="#fff" fontSize="24px" lineHeight="32px">
            {t('hubly-dashboard.signup.admin.left-side.description.text')}{' '}
            <Text color="#F03460">
              {t('hubly-dashboard.signup.admin.left-side.description.highlighted')}
            </Text>
          </OnlyDesktopText>

          <OnlyDesktopFlex flexDirection="column" justifyContent="space-between">
            <Text color="#fff" fontSize="16px" lineHeight="24px" marginBottom="16px">
              {t('hubly-dashboard.signup.admin.left-side.tags.title')}
            </Text>

            <Flex>
              <RadioTeste />
              <Text
                marginLeft="16px"
                color="#fff"
                fontSize="16px"
                lineHeight="24px"
                marginBottom="8px"
              >
                {t('hubly-dashboard.signup.admin.left-side.tags.items.orders')}
              </Text>
            </Flex>

            <Flex>
              <RadioTeste />
              <Text
                marginLeft="16px"
                color="#fff"
                fontSize="16px"
                lineHeight="24px"
                marginBottom="8px"
              >
                {t('hubly-dashboard.signup.admin.left-side.tags.items.commissions')}
              </Text>
            </Flex>

            <Flex>
              <RadioTeste />
              <Text marginLeft="16px" color="#fff" fontSize="16px" lineHeight="24px">
                {t('hubly-dashboard.signup.admin.left-side.tags.items.performance')}
              </Text>
            </Flex>
          </OnlyDesktopFlex>
        </>
      )}
    </Flex>
  );
};

export default Admin;
